import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

// @mui material components
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"

// Material Dashboard 2 React example components
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import MDInput from "components/MDInput"
import { Link } from "react-router-dom"
import { MenuItem } from "@mui/material"
import { FormControl, InputLabel, Select } from "@mui/material"
import FormControlLabel from "@mui/material/FormControlLabel"
import Switch from "@mui/material/Switch"
import Swal from "sweetalert2"

import { showToast } from "utils/swalToast"

// Importa el servicio de fetch para obtener, crear y editar usuarios
import {
  fetchPost,
  fetchDeviceById,
  updateDevice,
  fetchTipos,
  fetchNvrDevices,
  fetchZonas,
  fetchSucursales,
  fetchEventos,
  fetchEmpresas,
} from "../../service"
import ModalSelector from "components/ModalSelector"

const CAMERA_HIKVISION_TYPE = "CAMARAS_HIKVISION"

function Add() {
  const [deviceToEdit, setDeviceToEdit] = useState(null)
  const navigate = useNavigate()
  const { id } = useParams()
  const [optionEmpresa, setOptionEmpresa] = useState("")
  const [option, setOption] = useState("")
  const [optionEvento, setOptionEvento] = useState("")
  const [optionTipo, setOptionTipo] = useState("")
  const [optionZona, setOptionZona] = useState("")
  const [optionLinkedDevice, setOptionLinkedDevice] = useState("")
  const [formData, setFormData] = useState({
    description: "",
    brand: "",
    ip: "",
    type: "",
    state: "",
    sucursal: "",
    notifyUenovip: false,
  })
  const [empresas, setEmpresas] = useState([])
  const [sucursales, setSucursales] = useState([])
  const [eventos, setEventos] = useState([])
  const [zonas, setZonas] = useState([])
  const [tipos, setTipos] = useState([])
  const [nvrDevices, setNvrDevices] = useState([])

  const getLinkedDeviceId = (device) =>
    device?.nvr?.id ||
    device?.nvr?.idConfig ||
    device?.dispositivoVinculado?.id ||
    device?.dispositivoVinculado?.idConfig ||
    device?.linkedDevice?.id ||
    device?.nvrId ||
    device?.linkedDeviceId ||
    ""

  useEffect(() => {
    fetchEmpresas().then((data) => {
      setEmpresas(data)
    })
    fetchTipos().then((data) => {
      setTipos(data)
    })
  }, [])

  useEffect(() => {
    if (id) {
      fetchDeviceById(id).then((device) => {
        setDeviceToEdit(device)
        setFormData({
          description: device.description || "",
          brand: device.brand || "",
          ip: device.ip || "",
          type: device.type || "",
          state: device.state,
          zonas: device.zona || "",
          notifyUenovip: Boolean(device.notifyUenovip),
        })
        setOptionEmpresa(
          device.sucursales ? device.sucursales.empresa.idEmpresa : device.eventos.empresa.idEmpresa
        )
        if (device.sucursales?.empresa.idEmpresa) {
          fetchSucursales(device.sucursales.empresa.idEmpresa)
            .then((data) => {
              setSucursales(data)
              setOption(device.sucursales?.idSucursal)
            })
            .catch((error) => {
              console.error("Error fetching sucursales:", error)
            })
        }
        if (device.eventos?.empresa.idEmpresa) {
          fetchEventos(device.eventos.empresa.idEmpresa)
            .then((data) => {
              setEventos(data)
              setOptionEvento(device.eventos?.idEvento)
            })
            .catch((error) => {
              console.error("Error fetching eventos:", error)
            })
        }

        if (device.sucursales?.idSucursal) {
          fetchZonas(device.sucursales.idSucursal)
            .then((data) => {
              setZonas(data) // Update zonas state with fetched data
            })
            .catch((error) => {
              console.error("Error fetching zonas:", error)
            })
        }
        if (device.eventos?.idEvento) {
          fetchZonas(device.eventos.idEvento)
            .then((data) => {
              setZonas(data) // Update zonas state with fetched data
            })
            .catch((error) => {
              console.error("Error fetching zonas:", error)
            })
        }
        setOptionTipo(device.type)
        setOptionZona(device.zonas.idZona)
        setOptionLinkedDevice(getLinkedDeviceId(device))
      })
    }
  }, [id])

  useEffect(() => {
    if (optionTipo !== CAMERA_HIKVISION_TYPE || nvrDevices.length > 0) {
      return
    }

    fetchNvrDevices()
      .then((data) => {
        const nvrOptions = Array.isArray(data?._embedded?.configDeviceList)
          ? data._embedded.configDeviceList
          : Array.isArray(data)
            ? data
            : []
        setNvrDevices(nvrOptions)
      })
      .catch((error) => {
        console.error("Error fetching dispositivos NVR:", error)
      })
  }, [optionTipo, nvrDevices.length])

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value.trim(),
    }))
  }

  // Handler propio: handleChange hace value.trim() y de un Switch interesa checked.
  const handleNotifyUenovipChange = (event) => {
    if (event.target.checked) {
      setFormData((prev) => ({ ...prev, notifyUenovip: true }))
      return
    }
    Swal.fire({
      title: "¿Desactivar la notificación a ueno VIP?",
      text: "Este dispositivo dejará de enviar sus ingresos al webhook de ueno VIP.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, desactivar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        setFormData((prev) => ({ ...prev, notifyUenovip: false }))
      }
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const idSucursal = option ? parseInt(option, 10) : null
    const idEvento = optionEvento ? parseInt(optionEvento, 10) : null
    const idZona = optionZona ? parseInt(optionZona, 10) : null

    if (!idSucursal && !idEvento) {
      showToast({ title: "Debe seleccionar una sucursal o un evento", icon: "error" })
      return
    }
    if (!idZona) {
      showToast({ title: "Debe seleccionar una zona", icon: "error" })
      return
    }

    const linkedDeviceId = optionLinkedDevice ? parseInt(optionLinkedDevice, 10) : null;

    const data = {
      description: e.target.description.value,
      ip: e.target.ip.value,
      brand: e.target.brand.value,
      state: Boolean(formData.state),
      sucursales: { idSucursal },
      eventos: { idEvento },
      zonas: { idZona },
      idNvr: optionLinkedDevice,
      user: e.target.username.value,
      password: e.target.password.value,
      type: optionTipo,
      notifyUenovip: Boolean(formData.notifyUenovip),
    }

    if (linkedDeviceId) {
      data.nvr = { id: linkedDeviceId }
    }

    try {
      if (deviceToEdit) {
        await updateDevice(id, data)
        showToast({ title: "Dispositivo actualizado exitosamente", icon: "success" })
      } else {
        await fetchPost(data)
        showToast({ title: "Dispositivo agregado exitosamente", icon: "success" })
      }
      setTimeout(() => {
        navigate("/dispositivos")
      }, 2000)
    } catch (error) {
      console.error("Error en la operación:", error)
    }
  }

  const handleSucursalChange = (selectedId) => {
    setOptionEvento("")
    setOptionZona("")
    setOption(selectedId)
    fetchZonas(selectedId)
      .then((data) => {
        setZonas(data)
      })
      .catch((error) => {
        console.error("Error fetching zonas:", error)
      })
  }

  const handleEventoChange = (selectedIdEvento) => {
    setOption("")
    setOptionZona("")
    setOptionEvento(selectedIdEvento)
    fetchZonas(selectedIdEvento)
      .then((data) => {
        setZonas(data)
      })
      .catch((error) => {
        console.error("Error fetching zonas:", error)
      })
  }

  const handleEmpresaChange = (e) => {
    const selectedId = e.target.value
    setOptionEmpresa(selectedId)
    fetchSucursales(selectedId)
      .then((data) => {
        setSucursales(data)
      })
      .catch((error) => {
        console.error("Error fetching sucursales:", error)
      })
    fetchEventos(selectedId)
      .then((data) => {
        setEventos(data)
      })
      .catch((error) => {
        console.error("Error fetching eventos:", error)
      })
  }

  const handleTipoChange = (e) => {
    const selectedType = e.target.value
    setOptionTipo(selectedType)

    if (selectedType !== CAMERA_HIKVISION_TYPE) {
      setOptionLinkedDevice("")
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={3} mb={3}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={10}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant="h5">
                  {deviceToEdit ? "EDITAR DISPOSITITVO" : "AGREGAR DISPOSITIVO"}
                </MDTypography>
              </MDBox>
              <MDBox
                pt={2}
                px={2}
                id="formAddDis"
                onSubmit={handleSubmit}
                component="form"
                role="form"
              >
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Empresa</InputLabel>
                      <Select
                        type="text"
                        name="empresa"
                        value={optionEmpresa}
                        label="Empresa"
                        onChange={handleEmpresaChange}
                        fullWidth
                        sx={{ p: 1.5 }}
                      >
                        {empresas?.map((emp) => (
                          <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                            {emp.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ModalSelector
                      value={option}
                      onChange={handleSucursalChange}
                      items={sucursales}
                      itemValue="idSucursal"
                      itemLabel="descripcion"
                      label="Sucursal"
                      placeholder="Seleccione una sucursal"
                      searchPlaceholder="Buscar sucursal..."
                      emptyText="No se encontraron sucursales"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ModalSelector
                      value={optionEvento}
                      onChange={handleEventoChange}
                      items={eventos}
                      itemValue="idEvento"
                      itemLabel="descripcion"
                      label="Evento"
                      placeholder="Seleccione un evento"
                      searchPlaceholder="Buscar evento..."
                      emptyText="No se encontraron eventos"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ModalSelector
                      value={optionZona}
                      onChange={setOptionZona}
                      items={zonas}
                      itemValue="idZona"
                      itemLabel="descripcion"
                      label="Zona"
                      placeholder="Seleccione una zona"
                      searchPlaceholder="Buscar zona..."
                      emptyText="No se encontraron zonas"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth required>
                      <InputLabel>Tipo de Dispositivo</InputLabel>
                      <Select
                        type="text"
                        name="type"
                        value={optionTipo}
                        label="Tipo de Dispositivo"
                        onChange={handleTipoChange}
                        fullWidth
                        sx={{ p: 1.5 }}
                      >
                        {tipos?.map((empre) => (
                          <MenuItem key={empre.key} value={empre.key}>
                            {empre.value}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {optionTipo === CAMERA_HIKVISION_TYPE && (
                    <Grid item xs={12} md={6}>
                      <ModalSelector
                        value={optionLinkedDevice}
                        onChange={setOptionLinkedDevice}
                        items={nvrDevices}
                        itemValue="id"
                        itemLabel="description"
                        label="Dispositivo vinculado"
                        placeholder="Seleccione un dispositivo"
                        searchPlaceholder="Buscar dispositivo..."
                        emptyText="No se encontraron dispositivos"
                        fullWidth
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      name="description"
                      label="Nombre"
                      fullWidth
                      required
                      value={formData.description}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      name="ip"
                      label="TCP/IP"
                      fullWidth
                      required
                      value={formData.ip}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      name="brand"
                      label="Marca"
                      fullWidth
                      value={formData.brand}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="text"
                      name="username"
                      label="Usuario Dispositivo"
                      fullWidth
                      value={formData.username}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDInput
                      type="password"
                      name="password"
                      label="Password Dispositivo"
                      fullWidth
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <FormControlLabel
                      control={
                        <Switch
                          name="notifyUenovip"
                          checked={Boolean(formData.notifyUenovip)}
                          onChange={handleNotifyUenovipChange}
                        />
                      }
                      label="Notificar a ueno VIP"
                    />
                    <MDTypography variant="caption" color="text" display="block">
                      Si está activo, los ingresos de este dispositivo se envían al webhook de ueno
                      VIP.
                    </MDTypography>
                  </Grid>
                  <Grid item xs={12} md={12} textAlign={"center"} pb={2}>
                    <MDButton type="submit" variant="gradient" color="info" sx={{ width: "100%" }}>
                      {deviceToEdit ? "Actualizar" : "Agregar"}
                    </MDButton>
                    <Link to="/dispositivos">
                      <MDButton
                        type="button"
                        variant="outlined"
                        color="info"
                        sx={{ width: "100%", mt: 2 }}
                      >
                        Cancelar
                      </MDButton>
                    </Link>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Add
